var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import History from 'helpers/History';
import { T } from 'helpers/i18n';
import { Button, FieldType, Input } from 'elements';
var UserRecovery = /** @class */ (function (_super) {
    __extends(UserRecovery, _super);
    function UserRecovery() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            client: '',
            email: ''
        };
        _this.handleChange = function (event) {
            var _a;
            _this.setState((_a = {}, _a[event.target.name] = event.target.value, _a));
        };
        _this.handleSubmit = function () {
            _this.props.store.users
                .recovery(_this.state)
                .then(function () { return History.replace('/'); });
        };
        _this.handleCancel = function () {
            History.replace('/login');
        };
        return _this;
    }
    UserRecovery.prototype.render = function () {
        var _a = this.state, client = _a.client, email = _a.email;
        return (React.createElement(Wrapper, null,
            React.createElement(InsideWrapper, null,
                React.createElement(StyledInput, { label: T('client'), name: 'client', value: client, type: FieldType.Text, onChange: this.handleChange }),
                React.createElement(StyledInput, { label: T('email'), name: 'email', value: email, type: FieldType.Text, onChange: this.handleChange, onSubmit: this.handleSubmit })),
            React.createElement(ButtonWrapper, null,
                React.createElement(CancelButton, { secondary: true, onClick: this.handleCancel }, T('cancel')),
                React.createElement(SendButton, { primary: true, loading: 'post@login', onClick: this.handleSubmit }, T('send')))));
    };
    UserRecovery = __decorate([
        inject('store'),
        observer
    ], UserRecovery);
    return UserRecovery;
}(Component));
export default UserRecovery;
var Wrapper = cxs('div')({});
var InsideWrapper = cxs('div')({
    padding: Theme.size.space[4]
});
var ButtonWrapper = cxs('div')({
    borderTop: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    marginTop: Theme.size.space[1]
});
var StyledInput = cxs(Input)({
    padding: Theme.size.space[1]
});
var CancelButton = cxs(Button)({
    width: '50%',
    borderRight: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    padding: Theme.size.space[2]
});
var SendButton = cxs(Button)({
    width: '50%',
    padding: Theme.size.space[2]
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/Users/containers/UserRecovery.tsx
// module id = 1609
// module chunks = 0